export const CLASSES = {
  ECONOMICO: 'E',
  PRIMERA: 'P',
  LUJO: 'L'
}
